import { render, staticRenderFns } from "./JourneyOverview.vue?vue&type=template&id=62e91ae9&"
import script from "./JourneyOverview.vue?vue&type=script&lang=js&"
export * from "./JourneyOverview.vue?vue&type=script&lang=js&"
import style0 from "./JourneyOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports